export const REGIONS = ['England', 'Northern Ireland', 'Scotland', 'Wales'];

export const CITIES = {
  England: [
    'Bath',
    'Birmingham',
    'Bradford',
    'Brighton & Hove',
    'Bristol',
    'Cambridge',
    'Canterbury',
    'Carlisle',
    'Chelmsford',
    'Chester',
    'Chichester',
    'Colchester',
    'Coventry',
    'Derby',
    'Doncaster',
    'Durham',
    'Ely',
    'Exeter',
    'Gloucester',
    'Hereford',
    'Kingston-upon-Hull',
    'Lancaster',
    'Leeds',
    'Leicester',
    'Lichfield',
    'Lincoln',
    'Liverpool',
    'London',
    'Manchester',
    'Milton Keynes',
    'Newcastle-upon-Tyne',
    'Norwich',
    'Nottingham',
    'Oxford',
    'Peterborough',
    'Plymouth',
    'Portsmouth',
    'Preston',
    'Ripon',
    'Salford',
    'Salisbury',
    'Sheffield',
    'Southampton',
    'Southend-on-Sea',
    'St Albans',
    'Stoke on Trent',
    'Sunderland',
    'Truro',
    'Wakefield',
    'Wells',
    'Westminster',
    'Winchester',
    'Wolverhampton',
    'Worcester',
    'York',
  ],
  'Northern Ireland': ['Armagh', 'Bangor', 'Belfast', 'Lisburn', 'Londonderry', 'Newry'],
  Scotland: ['Aberdeen', 'Dundee', 'Dunfermline', 'Edinburgh', 'Glasgow', 'Inverness', 'Perth', 'Stirling'],
  Wales: ['Bangor', 'Cardiff', 'Newport', 'St Asaph', 'St Davids', 'Swansea', 'Wrexham'],
};
